export const GET_LIST_COMPANY = 'GET_LIST_COMPANY';
export const GET_LIST_COMPANY_SUCCESS = 'GET_LIST_COMPANY_SUCCESS';
export const GET_LIST_COMPANY_FAILED = 'GET_LIST_COMPANY_FAILED';

export const GET_SINGLE_COMPANY = 'GET_SINGLE_COMPANY';
export const GET_SINGLE_COMPANY_SUCCESS = 'GET_SINGLE_COMPANY_SUCCESS';
export const GET_SINGLE_COMPANY_FAILED = 'GET_SINGLE_COMPANY_FAILED';

export const GET_ALL_MODULES = 'GET_ALL_MODULES';
export const GET_ALL_MODULES_SUCCESS = 'GET_ALL_MODULES_SUCCESS';
export const GET_ALL_MODULES_FAILED = 'GET_ALL_MODULES_FAILED';

export const GET_LIST_EMPLOYEE = 'GET_LIST_EMPLOYEE';
export const GET_LIST_EMPLOYEE_SUCCESS = 'GET_LIST_EMPLOYEE_SUCCESS';
export const GET_LIST_EMPLOYEE_FAILED = 'GET_LIST_EMPLOYEE_FAILED';

export const SET_STATUS_EMPLOYEE = 'SET_STATUS_EMPLOYEE';
export const SET_STATUS_EMPLOYEE_SUCCESS = 'SET_STATUS_EMPLOYEE_SUCCESS';
export const SET_STATUS_EMPLOYEE_FAILED = 'SET_STATUS_EMPLOYEE_FAILED';

export const SET_SINGLE_COMPANY = 'SET_SINGLE_COMPANY';
export const SET_SINGLE_EMPLOYEE = 'SET_SINGLE_EMPLOYEE';
export const SET_COMPANY_PIC = 'SET_COMPANY_PIC';
export const GET_AVAILABLE_MODULES_INIT = 'GET_AVAILABLE_MODULES_INIT';
export const GET_AVAILABLE_MODULES_SUCCESS = 'GET_AVAILABLE_MODULES_SUCCESS';
export const GET_AVAILABLE_MODULES_ERROR = 'GET_AVAILABLE_MODULES_ERROR';
export const UPDATE_SELECTED_MODULES = 'UPDATE_SELECTED_MODULES';
export const UPDATE_SELECTED_MODULES_PERMISSION =
  'UPDATE_SELECTED_MODULES_PERMISSION';
export const UPDATE_EMPLOYEE_ROLES = 'UPDATE_EMPLOYEE_ROLES';
export const UPDATE_AVAILABLE_MODULES = 'UPDATE_AVAILABLE_MODULES';
export const INIT_SUBMIT_NEW_COMPANY = 'INIT_SUBMIT_NEW_COMPANY';
export const UPDATE_SUBMIT_MODAL_OPEN = 'UPDATE_SUBMIT_MODAL_OPEN';
export const UPDATE_CREATE_NEW_COMPANY_PARAMS =
  'UPDATE_CREATE_NEW_COMPANY_PARAMS';
export const UPDATE_CREATE_NEW_COMPANY_STEP = 'UPDATE_CREATE_NEW_COMPANY_STEP';
export const CREATE_ORGANIZATION_SUCCESS = 'CREATE_ORGANIZATION_SUCCESS';
export const CREATE_ORGANIZATION_ERROR = 'CREATE_ORGANIZATION_ERROR';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR';
export const CREATE_EMPLOYEE_SUCCESS = 'CREATE_EMPLOYEE_SUCCESS';
export const CREATE_EMPLOYEE_ERROR = 'CREATE_EMPLOYEE_ERROR';
export const UPDATE_SUBMIT_MODAL_FINISH_OPEN =
  'UPDATE_SUBMIT_MODAL_FINISH_OPEN';
export const UPDATE_SUBMIT_MODAL_ERROR_OPEN = 'UPDATE_SUBMIT_MODAL_ERROR_OPEN';
export const RETRY_ORGANIZATION = 'RETRY_ORGANIZATION';
export const RETRY_USER = 'RETRY_USER';
export const RETRY_EMPLOYEE = 'RETRY_EMPLOYEE';
export const RESET_AVAILABLE_MODULES = 'RESET_AVAILABLE_MODULES';
export const RESET_SUBMIT_MODAL = 'RESET_SUBMIT_MODAL';
export const INIT_SUBMIT_NEW_EMPLOYEE = 'INIT_SUBMIT_NEW_EMPLOYEE';

export const GET_LIST_ROLES_EMPLOYEE = 'GET_LIST_ROLES_EMPLOYEE';
export const GET_LIST_ROLES_EMPLOYEE_SUCCESS =
  'GET_LIST_ROLES_EMPLOYEE_SUCCESS';
export const GET_LIST_ROLES_EMPLOYEE_FAILED = 'GET_LIST_ROLES_EMPLOYEE_FAILED';
export const ACTIVATE_EMPLOYEE_ROLE_SUCCESS = 'ACTIVATE_EMPLOYEE_ROLE_SUCCESS';
export const DEACTIVATE_EMPLOYEE_ROLE_SUCCESS =
  'DEACTIVATE_EMPLOYEE_ROLE_SUCCESS';

export const GET_SINGLE_EMPLOYEE = 'GET_SINGLE_EMPLOYEE';
export const UPDATE_SINGLE_EMPLOYEE_PAYLOAD = 'UPDATE_SINGLE_EMPLOYEE_PAYLOAD';

export const GET_SINGLE_ROLE_EMPLOYEE = 'GET_SINGLE_ROLE_EMPLOYEE';
export const UPDATE_SINGLE_ROLE_EMPLOYEE_PAYLOAD =
  'UPDATE_SINGLE_ROLE_EMPLOYEE_PAYLOAD';

export const SHOW_ROLLBACK_MODAL = 'SHOW_ROLLBACK_MODAL';
export const CANCEL_ROLLBACK_MODAL = 'CANCEL_ROLLBACK_MODAL';
export const ROLLBACK_USER = 'ROLLBACK_USER';
export const ROLLBACK_ORGANIZATION = 'ROLLBACK_ORGANIZATION';
export const ROLLBACK_ERROR = 'ROLLBACK_ERROR';
export const ROLLBACK_SUCCESS = 'ROLLBACK_SUCCESS';
export const ROLLBACK_FINISH = 'ROLLBACK_FINISH';

export const INIT_SUBMIT_EDIT_EMPLOYEE = 'INIT_SUBMIT_EDIT_EMPLOYEE';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const UPDATE_EMPLOYEE_SUCCESS = 'UPDATE_EMPLOYEE_SUCCESS';
export const UPDATE_EMPLOYEE_ERROR = 'UPDATE_EMPLOYEE_ERROR';

export const UPDATE_INITIAL_USER_ROLES = 'UPDATE_INITIAL_USER_ROLES';
